import { ChakraProvider } from "@chakra-ui/react";

import theme from "@lib/theme";

import Modal from "../Modal";
import { TRenderModalFunction } from "../types";

const renderModal: TRenderModalFunction = ({ content, ...args }) => (
  <ChakraProvider theme={theme}>
    <Modal {...args} isOpen>
      {content}
    </Modal>
  </ChakraProvider>
);
export default renderModal;
